import { AbilityBuilder, Ability } from "@casl/ability";

export default function defineRulesFor(role) {
  const { can, rules } = new AbilityBuilder(Ability);
  switch (role) {
    case "SUPER_USER": {
      can("manage", "all");
      can("create", "communityCreation");
      break;
    }

    case "ADMIN": {
      can("manage", "all");
      break;
    }

    case "MEMBER": {
      can("read", "metrics");
      can("read", "communities");
      can("read", "generalInfo");
      can("read", "OMIE");
      can("read", "infrastructure");
      can("read", "loads");
      can("read", "market");
      can("read", "settlement");
      break;
    }

    default: {
      can("read", "metrics");
    }
  }

  return rules;
}

export function buildAbilityFor(role) {
  return new Ability(defineRulesFor(role));
}
